/**
 * Mind Studios Theme - Animations
 *
 * We use GSAP for animations that can't be done in CSS (or it'd be easier with GSAP)
 *
 * For documentation
 * @see https://gsap.com/
 */

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// All GSAP plugins need to be registered. (e.g. ScrollTrigger, MorphSVG, etc.)
gsap.registerPlugin(ScrollTrigger);

// Refresh ScrollTrigger offsets for lazy-loaded images
document.querySelectorAll("img").forEach((img) => img.addEventListener("load", () => ScrollTrigger.refresh(true)));

// [data-animate] will be added automatically to block-*.php files if they follow the basic structure
// You can use the attribute on other elements as well!
document.querySelectorAll("[data-animation='fade-in']").forEach((trigger) => {
    let elements = trigger;

    gsap.from(elements, {
        scrollTrigger: {
            trigger: trigger,
            start: "top bottom", // "element viewport" position
            end: "bottom bottom",
            once: true,
            markers: false, // Use this to debug trigger points
            fastScrollEnd: true,
            preventOverlaps: true,
        },
        duration: 1.5,
        y: 100,
        autoAlpha: 0,
    });
});

// Hero bubble: grow the masked image from small to full size on load.
if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    document.querySelectorAll(".hero__image").forEach((wrapper) => {
        gsap.from(wrapper, {
            x: 100,
            y: 20,
            scale: 0.9,
            duration: 1,
            ease: "power2.out",
        });
    });
}

// listing-*: each pill fades up (with a slight rotation) as it scrolls into view.
if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    document
        .querySelectorAll(".block-listing-icons__pill, .block-listing-floating__pill, .block-listing-numbered__pill")
        .forEach((pill) => {
            gsap.from(pill, {
                scrollTrigger: {
                    trigger: pill,
                    start: "top 97%",
                    once: true,
                },
                y: 40,
                rotation: -4,
                autoAlpha: 0,
                duration: 0.6,
                ease: "power2.out",
            });
        });
}

// listing-numbered: the number badge appears (small → full size) at the pill fade-up's midpoint.
if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    document.querySelectorAll(".block-listing-numbered__pill").forEach((pill) => {
        const num = pill.querySelector(".block-listing-numbered__num");
        if (!num) return;

        gsap.from(num, {
            scrollTrigger: {
                trigger: pill,
                start: "top 92%",
                once: true,
            },
            delay: 0.3, // half of the pill fade-up's 0.6s duration → fires at its midpoint
            scale: 0.4,
            autoAlpha: 0,
            duration: 0.4,
            ease: "back.out(1.7)",
        });
    });
}

// employees: cards fade up one by one, row by row, as each row scrolls into view.
if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    const employeeCards = gsap.utils.toArray(".content-employee");

    if (employeeCards.length) {
        gsap.set(employeeCards, { y: 40, autoAlpha: 0 });

        ScrollTrigger.batch(".content-employee", {
            start: "top 85%",
            once: true,
            onEnter: (batch) =>
                gsap.to(batch, {
                    y: 0,
                    autoAlpha: 1,
                    duration: 0.6,
                    ease: "power2.out",
                    stagger: 0.15,
                    overwrite: true,
                }),
        });
    }
}
